import empty from "../../../empty";

export default function _host(host) {
        this.$parent.$parent.$parent.host = host

    return empty
}
